import PageNotFound from "@/pages/404";
import About from "@/pages/About";
import Article from "@/pages/Article";
import Case from "@/pages/Case";
import Contact from "@/pages/Contact";
import Home from "@/pages/Home";
import Jobs from "@/pages/Jobs";
import Join from "@/pages/Join";
import Leadership from "@/pages/Leadership";
import Metaverse from "@/pages/Metaverse";
import News from "@/pages/News";
import PostPreview from "@/pages/PostPreview";
import Services from "@/pages/Services";
import SimplePage from "@/pages/SimplePage";
import TermsAndConditions from "@/pages/TermsAndConditions";
import Trainees from "@/pages/Trainees";
import Work from "@/pages/Work";
import JobsPreview from "@/pages/JobsPreview";
import LandingPage from "@/pages/LandingPage";
import CasePreview from "@/pages/CasePreview";

export const de = [
  {
    path: "/",
    name: "home-page",
    component: Home,
    meta: {
      title: "Home",
    },
  },
  {
    name: "post-preview",
    path: "/post-preview/:id/:preview_key",
    component: PostPreview,
  },
  {
    name: "post-preview-jobs",
    path: "/post-preview-jobs/:id/:preview_key",
    component: JobsPreview,
  },
  {
    name: "post-preview-case-studies",
    path: "/post-preview-case-studies/:id/:preview_key",
    component: CasePreview,
  },
  {
    path: "/arbeiten",
    name: "arbeiten",
    component: Work,
    meta: {
      title: "Arbeiten",
    },
    props: {
      slug: "arbeiten",
    },
  },
  {
    path: "/services/:slug?",
    name: "services-page",
    component: Services,
    meta: {
      title: "Services",
    },
    props: {
      slug_carousel: "arbeiten",
    },
  },
  {
    path: "/services",
    name: "services-page",
    component: Services,
    meta: {
      title: "Services",
    },
    props: {
      slug_carousel: "arbeiten",
    },
  },
  {
    path: "/uber-uns",
    name: "uber-uns",
    component: About,
    meta: {
      title: "Über Uns",
    },
    props: {
      slug: "uber-uns",
    },
  },
  {
    path: "/metaversum",
    name: "metaversum-page",
    component: Metaverse,
    meta: {
        title: "Metaversum",
    },
  },
  {
    path: "/news",
    name: "news-page",
    component: News,
    meta: {
      title: "News",
    },
  },
  {
    path: "/workatweber",
    name: "workatweber",
    component: Join,
    meta: {
      title: "#WORKATWEBER",
    },
    props: {
      slug: "workatweber",
    },
  },
  {
    path: "/datenschutz",
    name: "datenschutz",
    component: TermsAndConditions,
    meta: {
      title: "Datenschutz",
    },
    props: {
      slug: "datenschutz",
    },
  },
  {
    path: "/allgemeine-geschaftsbedingungen",
    name: "allgemeine-geschaftsbedingungen",
    component: TermsAndConditions,
    meta: {
      title: "Allgemeine Geschaftsbedingungen",
    },
    props: {
      slug: "allgemeine-geschaftsbedingungen",
    },
  },
  {
    path: "/impressum",
    name: "impressum",
    component: TermsAndConditions,
    meta: {
      title: "Impressum",
    },
    props: {
      slug: "impressum",
    },
  },
  {
    path: "/kontakt",
    name: "kontakt",
    component: Contact,
    meta: {
      title: "Kontakt",
    },
    props: {
      slug: "kontakt",
    },
  },
  {
    path: "/kontakt/:location",
    name: "kontakt-location",
    component: SimplePage,
    props: {
      slug: "kontakt",
    },
  },
  {
    path: "/arbeiten/:name",
    name: "arbeiten",
    component: Case,
    props: {
      slug: "arbeiten",
    },
  },
  {
    path: "/jobs/:name",
    name: "jobs",
    component: Jobs,
  },
  {
    path: "/trainees",
    name: "trainees",
    component: Trainees,
  },
  {
    path: "/leadership",
    name: "leadership",
    component: Leadership,
  },
  {
    path: "/landing-page/:name",
    name: "landing-page",
    component: LandingPage,
    props: {
      slug: "landing-page",
    },
  },
  {
    path: "/:category/:name",
    name: "article-page",
    component: Article,
  },
  {
    path: "*",
    name: "page-not-found",
    component: PageNotFound,
  },
];



// WEBPACK FOOTER //
// ./src/router/routes/de.js